import { xml2json, json2xml } from "xml-js";
import { FileService } from "../../services/file/FileService";
import { showSuccessToast } from "../../components/general/ToastHelper";
import { handleError } from "../../utils/ErrorHandlers";
import { tr } from "date-fns/locale";

// const createFile = (callFlow, flowName) => {
//   const startEndNodes = setupStartEndNodes();
//   let actionNodes;
//   callFlow.forEach((element) => {

//     let cellId = 4;
//     if (element.nodeType == 1) {
//       // actionNodes =
//       //   startEndNodes +
//       //   `<action><cell-id>${cellId}</cell-id><type>${
//       //     element.nodeType
//       //   }</type><index>${element.index}</index><next-goto>${
//       //     element.nextGoTo ? element.nextGoTo : 2
//       //   }</next-goto><stop-on-dtmf>0</stop-on-dtmf><list-size>1</list-size><file>${
//       //     element.promptName
//       //   }</file></action>`;
//       actionNodes =
//         startEndNodes +
//         setupPromptCell(
//           cellId,
//           element.nodeType,
//           element.index,
//           element.nextGoTo,
//           element.promptName
//         );
//       cellId++;
//       let i = element.index + 1;
//       element.children.forEach((elem) => {
//         if (elem.nodeType == 3) {
//           actionNodes =
//             actionNodes + createActionsFromChoices(elem, elem.children, cellId);
//         } else {
//           // actionNodes =
//           //   actionNodes +
//           //   `<action><cell-id>${cellId}</cell-id><type>${
//           //     elem.nodeType
//           //   }</type><index>${i}</index><next-goto>${
//           //     elem.nextGoTo ? elem.nextGoTo : 2
//           //   }</next-goto><stop-on-dtmf>0</stop-on-dtmf><list-size>1</list-size><file>${
//           //     elem.promptName
//           //   }</file></action>`;

//           actionNodes =
//             actionNodes +
//             setupPromptCell(
//               cellId,
//               elem.nodeType,
//               i,
//               elem.nextGoTo,
//               elem.promptName
//             );
//           i++;
//         }
//       });
//     } else {
//       actionNodes =
//         startEndNodes +
//         createActionsFromChoices(element, element.children, cellId);

//       cellId++;
//     }
//   });
//   const blob = new Blob([actionNodes + "</callflow>"], { type: "text/plain" });
//   const url = URL.createObjectURL(blob);
//   const link = document.createElement("a");
//   link.download = flowName + ".icf";
//   link.href = url;
//   link.click();
// };

// const setupStartEndNodes = () => {
//   return (
//     "<user-defined></user-defined>\n<callflow>\n<action>\n" +
//     "<cell-id>2</cell-id><type>s</type><index>0</index><next-goto>3</next-goto><call-type>1</call-type>\n" +
//     " </action>\n <action>\n<cell-id>3</cell-id><type>e</type><index>2</index>\n</action>\n"
//   );
// };

// const setupActionNodes = (node) => {};
// const setupEndFlowTag = () => {};

// const setupPromptCell = (cellId, nodeType, i, nextGoTo, promptName) => {
//   return `<action>\n<cell-id>${cellId}</cell-id><type>${nodeType}</type><index>${i}</index><next-goto>${
//     nextGoTo ? nextGoTo : 2
//   }</next-goto><stop-on-dtmf>0</stop-on-dtmf><list-size>1</list-size><file>${promptName}</file>\n</action>\n`;
// };

// const createActionsFromChoices = (parent, choices, id) => {
//   let actionChoices = `<action>\n<cell-id>${id}</cell-id><type>${parent.nodeType}</type><index>${parent.index}</index><retry>1</retry><next-if-false>0</next-if-false><next-if-invalid>2</next-if-invalid><next-if-timeout>2</next-if-timeout><timeout>10</timeout><mode>1</mode>
//         <map-size>${choices.length}</map-size>`;
//   let actionCells = [];
//   let i = parent.index + 1;
//   id++;
//   choices.forEach((element) => {
//     if (element.promptName) {
//       // actionCells.push(
//       //   `<action><cell-id>${id}</cell-id><type>1</type><index>${i}</index><stop-on-dtmf>0</stop-on-dtmf><list-size>1</list-size><file>${element.promptName}</file></action>`
//       // );
//       actionCells.push(setupPromptCell(id, 1, i, 2, element.promptName));
//       actionChoices = actionChoices + `<map>${element.mapping + i}</map>`;
//       i++;
//       id++;
//     } else if (element.groupName) {
//       if (element.waitingVoiceName) {
//         actionCells.push(
//           `<action>\n<cell-id>${id}</cell-id><type>8</type><index>${i}</index><group-name>${element.groupName}</group-name><file>${element.waitingVoiceName}</file>\n</action>\n`
//         );
//       } else {
//         actionCells.push(
//           `<action>\n<cell-id>${id}</cell-id><type>8</type><index>${i}</index><group-name>${element.groupName}</group-name>\n</action>\n`
//         );
//       }
//       actionChoices = actionChoices + `<map>${element.mapping + i}</map>`;
//       i++;
//       id++;
//     }
//   });

//   actionChoices = actionChoices + "\n</action>\n" + actionCells.join(" ");
//   return actionChoices;
// };

const covertJson2XmlAndUploadCallFlow = async (
  JsonCallFlowz,
  flowName,
  sessionId,
  treeData,
  editFlag,
  fileId
) => {
  let JsonCallFlow = {
    "user-defined": "",
    callflow: {
      action: [
        {
          "cell-id": 2,
          type: "s",
          index: 0,
          "next-goto": 3,
          "call-type": 1,
        },
        {
          "cell-id": 3,
          type: "e",
          index: 2,
        },
      ],
    },
  };
  JsonCallFlow = getJsonForXmlConversion(JsonCallFlow, treeData);
  const xml = json2xml(JsonCallFlow, {
    compact: true,
    spaces: 4,
  });

  const blob = new Blob(["<user-defined>" + xml], {
    type: "application/octet-stream",
  });
  blob.name = flowName.includes(".icf") ? flowName : flowName + ".icf";
  let filename = flowName.includes(".icf") ? flowName : flowName + ".icf";
  let file = new File([blob], filename, {
    type: "application/octet-stream",
  });

  const blobWeb = new Blob([JSON.stringify(treeData)], {
    type: "application/octet-stream",
  });
  blobWeb.name = flowName.includes(".icf") ? flowName : flowName + ".icf";
  let fileWeb = new File([blobWeb], filename, {
    type: "application/octet-stream",
  });
  return await handleUpload(file, fileWeb, sessionId, editFlag,fileId);
};
const handleUpload = async (blobCTI, blobWeb, session_id, editFlag,fileId) => {
  let fileService = new FileService();
  try {
    // let response = await fileService.uploadCallFlow(session_id, blobCTI);
    if (editFlag) {
      let response = await fileService.editDevelopedCallFlow(
        session_id,
        blobCTI,
        blobWeb,
        fileId
      );
    } else {
      let responseDevelopedCallFlow = await fileService.uploadDevelopedCallFlow(
        session_id,
        blobCTI,
        blobWeb
      );
    }
    showSuccessToast("uploaded successfully");
    return true;
  } catch (e) {
    // handleError(e);
    throw new Error(e.message);
  }
};

const getJsonForXmlConversion = (JsonCallFlow, treeData) => {
  for (let element of treeData) {
    if (element.type == "1") {
      JsonCallFlow.callflow.action.push({
        "cell-id": element["cell-id"],
        type: element.type,
        index: element.index,
        "next-goto": element["next-goto"],
        "stop-on-dtmf": element["stop-on-dtmf"],
        "list-size": element["list-size"],
        file: element.file,
      });
    }
    if (element.type == "3") {
      JsonCallFlow.callflow.action.push({
        "cell-id": element["cell-id"],
        type: element.type,
        index: element.index,
        retry: element.retry,
        "next-if-false": element["next-if-false"],
        "next-if-invalid": element["next-if-invalid"],
        "next-if-timeout": element["next-if-timeout"],
        timeout: element.timeout,
        mode: element.mode,
        "map-size": element["map-size"],
        map: element.map,
      });
    }
    if (element.type == "8") {
      let groupStep = {
        "cell-id": element["cell-id"],
        type: element.type,
        index: element.index,
        "group-name": element["group-name"],
      };
      if (element.file) {
        groupStep.file = element.file;
      }
      JsonCallFlow.callflow.action.push(groupStep);
    }
    if (element.children && element.children.length > 0) {
      getJsonForXmlConversion(JsonCallFlow, element.children);
    }
  }

  return JsonCallFlow;
};

export default covertJson2XmlAndUploadCallFlow;
